import { sendMQTTMessage, parseMqttResult } from '../helper'
import { IMQTTRes } from '../type'

export function pauseAllTasks () {
  return sendMQTTMessage('xl_shell', 'pause_lixian_tasks_all')
}

export function pauseTasks (userId: string, downloadIds: string[]) {
  return sendMQTTMessage('xl_shell', 'pause_lixian_tasks', {
    plat_form: 'pc',
    client_id: '',
    user_id: userId,
    download_ids: downloadIds,
  })
}

export function resumeTasks (userId: string, downloadIds: string[]) {
  return sendMQTTMessage('xl_shell', 'resume_lixian_tasks', {
    plat_form: 'pc',
    client_id: '',
    user_id: userId,
    download_ids: downloadIds,
  })
}

export function resumeAllTasks () {
  return sendMQTTMessage('xl_shell', 'resume_lixian_tasks_all')
}

export function removeLixianTasks (userId: string, downloadIds: string[]) {
  return sendMQTTMessage('xl_shell', 'remove_lixian_tasks', {
    plat_form: 'pc',
    client_id: '',
    user_id: userId,
    download_ids: downloadIds,
  })
}

export type TInspectUrlParams = {
  download_id: string
  url: string
  download_path: string
  page_token?: string
  user_id?: string
}

export interface IFile {
  file_name: string
  file_size: number
  file_path: string
  is_exist: boolean
  status: number
  errno: number
  index: number
}

export type TInspectUrlRes = IMQTTRes<{
  download_id: string
  name: string
  total_size: string
  total_file_nums: number
  total_downloaded: number
  status: string
  downloaded: string
  files: IFile[]
  page_token: string
}>

export function inspectUrl (params: TInspectUrlParams): Promise<TInspectUrlRes> {
  return sendMQTTMessage('xl_shell', 'inspect_url', Object.assign({
    plat_form: 'pc',
    page_token: '',
    page_size: 100,
  }, params))
    .then(parseMqttResult)
}

type TSubmitLixianTasksParams = {
  group_id: string
  user_id: string
  client_id: string
  plat_form: 'pc'
  urls: Array<{ url: string; download_path?: string }>
  only_video?: boolean
}

export function submitLixianTasks (params: TSubmitLixianTasksParams) {
  return sendMQTTMessage('xl_shell', 'submit_lixian_tasks', params)
    .then(parseMqttResult)
}

type TGetLixianTasksParams = {
  group_id: string
  urls?: Array<string>
}

export function getLixianTasks (params: TGetLixianTasksParams) {
  return sendMQTTMessage('xl_shell', 'get_lixian_tasks', params)
    .then(parseMqttResult)
}

type TCreateLixianTasksParams = {
  user_id: string
  url: string
  message_id?: string
  indexs?: Array<{ index: number; file_size: number }>
  plat_form: 'pc'
  client_id: string
  download_path: string
  recreate: boolean
}

export function createLixianTasks (params: TCreateLixianTasksParams) {
  return sendMQTTMessage('xl_shell', 'create_lixian_tasks', params)
    .then(parseMqttResult)
}

export function inspectLixianTasksBatch (params: { urls: string[] }) {
  return sendMQTTMessage('xl_shell', 'inspect_lixian_tasks_batch', params)
    .then(parseMqttResult)
}

/** 迅雷口令解析结果 */
interface IXlShareLinkParsedData {
  /** 见task.name */
  filename: string
  /** 见task.size */
  filesize: string
  /** 见task.sensitive */
  sensitive: string
  /** 口令携带的密码 */
  passwd: string
  /** 口令类型: 普通口令 | 马甲口令 | 加密口令 */
  type: 'common' | 'vest' | 'encrypted'
  /** 见task.url */
  url: string
  /** 由于迅雷口令可能包含多项磁力链接，统一在此字段中将磁力链信息返回 */
  tasks: Array<{
    name: string
    sensitive: string
    size: number
    /** 磁力链链接 */
    url: string
  }>
}
/** 解析迅雷口令，将http解析结果统一数据结构 */
export async function parseXlShareLink (text: string, traceId = '') {
  return sendMQTTMessage<IMQTTRes<IXlShareLinkParsedData>>('xl_shell', 'inspect_pw', { text, traceId }).then(data => {
    const { result } = parseMqttResult<IXlShareLinkParsedData>(data)
    const { tasks } = result
    if (tasks.every(task => !task.url)) {
      throw new Error('口令已失效')
    }
    return result
  })
}